function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#joyspace_svg__a)",
  fill: "#787B86"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.01 7.24c0-.298-.005-.475-.025-.63a3.001 3.001 0 00-2.582-2.584C17.208 4 16.976 4 16.511 4H10c.116.104.247.234.462.45l.55.551c.816.816 1.224 1.224 1.711 1.496.269.149.554.267.849.352.537.153 1.114.153 2.268.153h.373c1.779 0 2.956 0 3.797.238z",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.455 3c.347 0 .522 0 .69.016.72.067 1.404.35 1.961.813.13.107.253.23.5.476l.494.495c.734.734 1.101 1.102 1.54 1.346.242.134.499.24.764.316.484.138 1.004.138 2.041.138h.337c2.369 0 3.554 0 4.323.693.071.063.139.13.202.201.693.77.693 1.956.693 4.324V13.8c0 3.394 0 5.091-1.055 6.145C18.89 21 17.194 21 13.8 21h-3.6c-3.394 0-5.091 0-6.145-1.055C3 18.89 3 17.194 3 13.8V7.455c0-.794 0-1.191.063-1.522a3.6 3.6 0 012.869-2.87C6.264 3.001 6.662 3 7.455 3zm4.76 8c-1.421 0-2.572.948-2.572 2.118 0 .252.054.5.159.734-.12-.02-.246-.029-.374-.029-1.064 0-1.928.712-1.928 1.59 0 .876.864 1.587 1.928 1.587h4.5c1.421 0 2.572-.948 2.572-2.118 0-.927-.724-1.714-1.73-2.002-.143-1.057-1.233-1.88-2.555-1.88z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "joyspace_svg__clip0_484_5038"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));

var SvgJoyspace = function SvgJoyspace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#joyspace_svg__clip0_484_5038)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "joyspace_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _ref), _ref2), _ref3);
};

export default SvgJoyspace;